import request from '@/axios'
//course/create/2
export function createCourse (payload, customer_id) {
  return request({
    url:`/course/create/${customer_id}`,
    method:'POST',
    data:payload
  })
}

// api/lesson/create/2

export function createLesson (payload, customer_id) {
  return request({
    url:`/lesson/create/${customer_id}`,
    method:'POST',
    data:payload
  })
}
//api/topic/create/2
export function createTopic (payload, customer_id) {
  return request({
    url:`/topic/create/${customer_id}`,
    method:'POST',
    data:payload
  })
}

// http://localhost:8000/api/topic/create/2

export function courseListing (customer_id, payload, queryParams = 1) {
  return request({
    url:`/course/list/${customer_id}?page=${queryParams}`,
    method:'POST',
    data:payload
  })
}


export function lessonListing (customer_id, payload, queryParams = 1) {
  return request({
    url:`/lesson/list/${customer_id}?page=${queryParams}`,
    method:'POST',
    data:payload
  })
}

export function topicListing (customer_id, payload, queryParams = 1) {
  return request({
    url:`/topic/list/${customer_id}?page=${queryParams}`,
    method:'POST',
    data:payload
  })
}

export function ChangeLessonStatus (customer_id, payload) {
  return request({
    url:`/lesson/change-status/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function changeCourseStatus (customer_id, payload) {
  return request({
    url:`/course/change-status/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function changeTopicStatus (customer_id, payload) {
  return request({
    url:`/topic/change-status/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function deleteCourse (customer_id, payload) {
  return request({
    url:`/course/delete/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function deleteLesson (customer_id, payload) {
  return request({
    url:`/lesson/delete/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function deleteTopic (customer_id, payload) {
  return request({
    url:`/topic/delete/${customer_id}`,
    method:'POST',
    data:payload
  })

 
}
export function contentFileUpload (customer_id, payload) {
  return request({
    url:`/ClientUser/file/upload/${customer_id}`,
    method:'POST',
    data:payload

  })
}

export function getUploadedFilesId (payload) {
  return request({
    url:'/ClientUser/upload/add',
    method:'POST',
    data:payload
    
  })
}

export function deleteAssignmentOrQuesion (customer_id, payload) {
  return request({
    url:`/course/remove-assignment-or-question/${customer_id}`,
    method:'POST',
    data:payload

  })
}

export function saveCourseSettings (customer_id, payload) {
  return request({
    url:`/course/setting/${customer_id}`,
    method:'POST',
    data:payload
   

  })
}


// http://localhost:8000/api/course/remove-assignment-or-question/2